// calculations and tables from: https://www.irs.gov/pub/irs-pdf/p15t.pdf
// "2022 Percentage Method Tables for Automated Payroll Systems"
// Standard Withholding Rate Schedules

// Updated with 2024 numbers as of 1/9/2022

const singleIncome = [
  [0, 6000],
  [6001, 17600],
  [17601, 53150],
  [53151, 106525],
  [106526, 197950],
  [197951, 249725],
  [249726, 615350],
  [615351, Infinity]
]

const doubleIncome = [
  [0, 16300],
  [16301, 39550],
  [39551, 110600],
  [110601, 217350],
  [217351, 400200],
  [400201, 503750],
  [503751, 747500],
  [747501, Infinity]
]

const ranges = {
  "single": singleIncome,
  "married-separately": singleIncome,

  "married": doubleIncome,
  "married-jointly": doubleIncome,

  "head-of-household": [
    [0, 13300],
    [13301, 29850],
    [29851, 76400],
    [76401, 113800],
    [113801, 205250],
    [205251, 257000],
    [257001, 622650],
    [622651, Infinity]
  ]
}

const singleIncomeOther = [
  [0, 0],
  [0, 0.1],
  [1160, 0.12],
  [5426, 0.22],
  [17168.5, 0.24],
  [39110.5, 0.32],
  [55678.5, 0.35],
  [183647.25, 0.37]
]

const doubleIncomeOther = [
  [0, 0],
  [0, 0.1],
  [2320, 0.12],
  [10852, 0.22],
  [34337, 0.24],
  [78221, 0.32],
  [111357, 0.35],
  [196669.5, 0.37]
]

const amountToWithholdIndex = {
  "single": singleIncomeOther,
  "married-separately": singleIncomeOther,

  "married": doubleIncomeOther,
  "married-jointly": doubleIncomeOther,

  "head-of-household": [
    [0, 0],
    [0, 0.1],
    [1655, 0.12],
    [7241, 0.22],
    [15469, 0.24],
    [37417, 0.32],
    [53977, 0.35],
    [181954.5, 0.37]
  ]
}

export const getTaxWithholding = (filingStatus, annualIncome) => {
  const incomeRangeIndex = ranges[filingStatus].findIndex(([low, high]) => annualIncome >= low && annualIncome <= high)
  const [amountToWithhold, percentage] = amountToWithholdIndex[filingStatus][incomeRangeIndex]
  const [lowerEndOfRange, _] = ranges[filingStatus][incomeRangeIndex]
  return incomeRangeIndex > 0 ? Math.round(amountToWithhold + percentage * (annualIncome - lowerEndOfRange)) : 0
}
